import type { REALTIME_SUBSCRIBE_STATES } from '@supabase/supabase-js';

/**
 * Bug K cold-start defense (2026-05-08). Lesson 5 (CLAUDE.md):
 * Realtime architectures always have a gap between component mount
 * and SUBSCRIBED status. Anything that lands in that gap is
 * invisible until the next manual refresh — exactly the stale-mount
 * artifact that surfaced on the 141K thread reproduction.
 *
 * Wrap any `.subscribe(...)` callback with this helper so the
 * cold-start refetch fires on (and only on) SUBSCRIBED. Other
 * statuses (CHANNEL_ERROR / TIMED_OUT / CLOSED) are teardown paths
 * and MUST NOT refetch — that would cause a refetch storm on a
 * dropped websocket.
 *
 * Usage:
 *   .subscribe(onColdStart(() => {
 *     void utils.conversations.projectThreeCs.invalidate({ projectId });
 *   }))
 *
 * Grep-ability: `grep -rn "onColdStart" client/src` surfaces every
 * subscription site. Any new Realtime subscriber not using this
 * helper is visible in PR review — that's the point.
 */
export function onColdStart(onSubscribed: () => void) {
  return (status: `${REALTIME_SUBSCRIBE_STATES}`): void => {
    if (status === 'SUBSCRIBED') onSubscribed();
  };
}
